var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.$ceres.isSSR,
          expression: "!$ceres.isSSR",
        },
      ],
      staticClass: "cookie-bar out",
      class: { in: _vm.isVisible },
    },
    [
      _vm.isVisible
        ? _c("div", { staticClass: "container" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isExpanded,
                    expression: "!isExpanded",
                  },
                ],
                staticClass: "row pt-3",
                class: _vm.classes,
                style: _vm.styles,
              },
              [
                _c("div", { staticClass: "col-12 text-center" }, [
                  _c("span", { staticClass: "h2" }, [
                    _vm._v("Datenschutz-Einstellungen"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      '\n                    Wir und unsere Partner verarbeiten Ihre persönlichen Daten mit Hilfe von Cookies\n                    sowie ähnlichen Technologien, um Informationen auf Ihrem Gerät zu speichern, für personalisierte \n                    Werbung und Inhalte, zur Messungen von Werbung und Inhalten und zur Weiterentwicklung unserer \n                    Angebote.\n                    Sie haben die Möglichkeit, selbst zu bestimmen, welche Daten erfasst werden sollen. Mit einem\n                    Klick auf "Einverstanden" akzeptieren Sie alle Cookies und gelangen direkt zur Website.\n                    Alternativ können Sie unter "Einstellungen" eine ausführliche Beschreibung der\n                    eingesetzten Cookies und ihrer Verwendungszwecke einsehen und Ihre Präferenzen entsprechend\n                    anpassen. Sollten Sie auf ein personalisiertes Einkaufserlebnis verzichten wollen, klicken Sie\n                    bitte '
                    ),
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            _vm.storeConsents()
                            _vm.close()
                          },
                        },
                      },
                      [_vm._v("hier")]
                    ),
                    _vm._v(
                      ". Ihre Einwilligung ist freiwillig und kann\n                    jederzeit über die Datenschutz-Einstellungen widerrufen oder geändert werden. "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "d-inline-block read_more",
                        attrs: { href: "/privacy-policy/" },
                      },
                      [_vm._v("Daten­schutz­erklärung")]
                    ),
                    _vm._v(" | "),
                    _c(
                      "a",
                      {
                        staticClass: "d-inline-block read_more",
                        attrs: { href: "/legal-disclosure/" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.legalDisclosure")
                          )
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-12 text-center pb-4 pt-1" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-default btn-appearance d-inline-block",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            _vm.isExpanded = true
                          },
                        },
                      },
                      [_vm._v("Einstellungen")]
                    ),
                    _vm._v(" "),
                    _c("button", {
                      staticClass:
                        "btn btn-primary btn-appearance d-inline-block",
                      attrs: {
                        onclick:
                          "consentGiven(window.ConsentManager.hasResponse())",
                      },
                      domProps: {
                        innerHTML: _vm._s("Einverstanden, zum Shop &rarr;"),
                      },
                      on: {
                        click: function ($event) {
                          _vm.acceptAll()
                          _vm.close()
                        },
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.isExpanded
              ? _c(
                  "div",
                  {
                    staticClass: "row privacy-details",
                    class: _vm.classes,
                    style: _vm.styles,
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-12 mb-3" },
                      [
                        _c("privacy-settings", {
                          attrs: { "consent-groups": _vm.consentGroups },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-12 text-center" }, [
                      _c("button", {
                        staticClass: "btn btn-default mr-2",
                        attrs: {
                          onclick:
                            "consentGiven(window.ConsentManager.hasResponse())",
                        },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate("Ceres::Template.cookieBarSave")
                          ),
                        },
                        on: {
                          click: function ($event) {
                            _vm.storeConsents()
                            _vm.close()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("button", {
                        staticClass:
                          "btn btn-primary btn-appearance cookiesAccept",
                        attrs: {
                          onclick:
                            "consentGiven(window.ConsentManager.hasResponse())",
                        },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate("Ceres::Template.cookieBarAcceptAll")
                          ),
                        },
                        on: {
                          click: function ($event) {
                            _vm.acceptAll()
                            _vm.close()
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-6" }, [
                      _c("a", {
                        staticClass: "text-appearance d-inline-block mb-3",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate("Ceres::Template.cookieBarBack")
                          ),
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            _vm.isExpanded = false
                          },
                        },
                      }),
                    ]),
                  ]
                )
              : _vm._e(),
          ])
        : _c("div", [
            _c(
              "a",
              {
                attrs: {
                  "aria-label": _vm.$translate(
                    "Ceres::Template.cookieBarPrivacySettings"
                  ),
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    _vm.isCollapsed = false
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-shield float-none",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "d-inline-block",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$translate("Ceres::Template.cookieBarPrivacySettings")
                    ),
                  },
                }),
              ]
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }